import { ChangeEvent, useEffect, useState } from "react"
import { AiFillPlusCircle } from "react-icons/ai";
import { LuTrash2 } from "react-icons/lu";

import { jsonKeyToString } from "../../../helpers/jsonToString"
import { useDispatch } from 'react-redux'
import { CustomFieldsProps } from "./SettingsCustoms"
import { useSetSettings } from "../../../api/useSettings"
import { SpinnerCustom } from "../../ui/SpinnerCustom"
import toast from "react-hot-toast"
import { startChecking } from "../../../store/asyncMethods/authMethods"
import { ModalAddItem } from "../../modals/ModalAddItem";
import { DetailName } from "../../../interfaces/interfaces";
import { inputJson } from "../../../helpers/eliminarEs";

interface Props {
    field: CustomFieldsProps
}

interface CheckData {
    check: boolean
    key: string,
}
export const CustomFields = ({ field }: Props) => {

    const [data, setData] = useState<CheckData[]>([])
    const [dataCustom, setDataCustom] = useState<CheckData[]>([])
    const [openModal, setOpenModal] = useState<boolean>(false)

    const { mutate, isLoading } = useSetSettings()
    const dispatch = useDispatch()

    const inmutableFields = ["pallet_ref", "supplier", "product"]

    useEffect(() => {
        const allMain: CheckData[] = []
        field.validItems.forEach((key) => {
            allMain.push(
                {
                    check: field.checkedItems.includes(key) ? true : false,
                    key,
                }
            )
        })
        setData(allMain)
    }, [field.validItems])

    useEffect(() => {
        if (!field.personalItems) return
        const personalFields: CheckData[] = []
        field.personalItems.forEach((key) => {
            personalFields.push(
                {
                    check: field.checkedItems.includes(key) ? true : false,
                    key,
                }
            )
        })
        setDataCustom(personalFields)

    }, [field.personalItems])


    const handleCheck = (e: ChangeEvent<HTMLInputElement>, isCustom?: boolean) => {

        const checkItem = (isCustom ? dataCustom : data).map(item => {
            if (item.key === e.target.name) {
                return {
                    ...item,
                    check: !item.check
                }
            }
            return item
        })

        isCustom ? setDataCustom(checkItem) : setData(checkItem)
    }

    const handleSend = () => {
        const newData: string[] = []
        const newDataCustom: string[] = []
        data.forEach(item => {
            if (item.check) {
                newData.push(item.key)
            }
        })
        dataCustom.forEach(item => {
            if (item.check) {
                newData.push(item.key)
            }
        })
        dataCustom.forEach(item => {
            newDataCustom.push(item.key)
        })

        if ((newData.length + newDataCustom.length) === 0) {
            return toast.error("You must select at least one field")
        }

        mutate({ property: field.property, data: newData, dataCustom: newDataCustom }, {
            onSuccess: () => {
                dispatch(startChecking())
                toast.success('Settings updated')
            }
        })
    }

    const addItem = (newLabel: string) => {

        const newItem = inputJson(newLabel.trim())

        if (newItem.length <= 0) return toast.error('Input Name incomplete')
        if (!/^[a-zA-Z_ ]*$/.test(newItem)) return toast.error('Input Name should only contain letters')
        if (data.find(item => item.key === newItem)) return toast.error('This Item already exist')
        if (dataCustom.find(item => item.key === newItem)) return toast.error('This Item already exist')

        setDataCustom(prev => [...prev, { check: true, key: newItem }])
        setOpenModal(false)
    };

    const deleteCustomItem = (itemName: string) => {
        const filtred = dataCustom.filter(item => item.key !== itemName)
        setDataCustom(filtred)
    };

    return (
        <>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2">
                {
                    data.map(item => (
                        <div key={item.key} className="tw-flex tw-items-center">
                            {
                                <input
                                    type="checkbox"
                                    name={item.key}
                                    checked={item.check}
                                    onChange={handleCheck}
                                    disabled={inmutableFields.includes(item.key)}
                                />
                            }
                            <label className="tw-flex tw-items-center tw-ml-2">{jsonKeyToString(item.key)}</label>
                        </div>

                    ))
                }
                {
                    dataCustom.map(item => (
                        <div key={item.key} className="tw-flex tw-items-center">
                            {
                                <input
                                    type="checkbox"
                                    name={item.key}
                                    checked={item.check}
                                    onChange={(e) => handleCheck(e, true)}
                                />
                            }
                            <label className="tw-flex tw-items-center tw-ml-2">{jsonKeyToString(item.key)}
                                <button className="tw-ml-2" onClick={() => deleteCustomItem(item.key)}><LuTrash2 size={15}/></button>
                            </label>
                        </div>

                    ))
                }


            </div>

            <div className="tw-w-full tw-flex tw-justify-between tw-items-center tw-mt-2">

                {
                    openModal &&
                    <ModalAddItem
                        closeModal={() => setOpenModal(false)}
                        addPallItem={addItem}
                        detailName={field.property as DetailName}
                        onlyLabel
                    />
                }

                {
                    field.property === "mainData"
                        ? <div />
                        :
                        <button className="tw-flex tw-items-center tw-gap-1" onClick={() => setOpenModal(true)}>
                            <AiFillPlusCircle size={22} className="tw-text-blue-600" />
                            <p className="tw-text-blue-600 tw-text-sm">New item</p>
                        </button>
                }


                <button
                    onClick={handleSend}
                    disabled={isLoading}
                    className="tw-bg-green-600 tw-text-white tw-rounded-full tw-py-2 tw-px-6 tw-mt-2 tw-flex tw-items-center tw-gap-2"
                >
                    Save
                    {isLoading && <SpinnerCustom color="white" />}
                </button>
            </div>
        </>
    )
}
